export default __webpack_public_path__ + "static/media/659.91da3331.png";